<template>
    <div>
         <van-button type="info" :style="loginStyle" @click="signInwx" weixin:
          >点击分享</van-button
        >
    </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    signInwx() {
      let clientType = 'android_ys';
      let param = {
        tag: "shareApp",
        url: "http://hzstg.ksbao.com/drawingpapersTest/#/home?agentCode=888&configID=13613",
        title: "抽题组卷",
        content: "https://yxwz.ksbao.com/share/img/bdShare.png",
        label: "双十一活动"
      };
      if (clientType == "android_ys") {
        if (window.KtJsUtil) {
          window.KtJsUtil.toAndroidListener(JSON.stringify(param));
        } else {
          
        }
      } else if (clientType == "iphoneYuanSheng") {
        window.webkit.messageHandlers.shareApp.postMessage(param);
      }
    }
  }
};
</script>
<style >
</style>